<template>
  <div></div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  created () {
    this.$router.replace(this.$route.query.router)
  }
}
</script>

<style>

</style>